import '@quasar/extras/roboto-font/roboto-font.css'
import '@quasar/extras/material-icons/material-icons.css'

import 'quasar/src/css/index.sass'

import quasarIconSet from 'quasar/icon-set/svg-material-icons'

export const quasarOptions = {
  plugins: {}, // import Quasar plugins and add here
  iconSet: quasarIconSet,
}